import _ from 'lodash'
import React, {Component} from 'react'
import autoBind from 'react-autobind'
import {Container, Form, Image, Segment} from 'semantic-ui-react'

import done from '../../../assets/images/done.png'
import cancel from '../../../assets/images/cancel.png'
import {tr} from '../../../helpers/languages'

class OtherExercise extends Component {
    constructor(props) {
        super(props)
        this.state = {
            exercise: this.props.exercise || {
                title: '',
                description: '',
                custom_link: ''
            },
            errors: {}
        }
        autoBind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({exercise: nextProps.exercise || {title: '', description: '', type: 'assigned', custom_link: ''}})
    }

    // Changes the value of some field.
    changeValue(field, value) {
        this.setState({exercise: {...this.state.exercise, [field]: value}})
    }

    // Saves the exercise.
    saveExercise() {
        // Clear all errors.
        this.setState({errors: {}})

        // Validate.
        let errors = {}

        // The title is required.
        if (_.isEmpty(this.state.exercise.title)) {
            errors = {...errors, title: tr('TITLE_REQUIRED')}
        }

        // The description is required.
        if (_.isEmpty(this.state.exercise.description)) {
            errors = {...errors, description: tr('DESCRIPTION_REQUIRED')}
        }

        // There are errors. Break.
        if (!_.isEmpty(errors)) {
            this.setState({errors})
            return
        }

        // Save the exercise.
        this.props.onDone(this.state.exercise, this.props.index)
    }

    render() {
        return (
            <Container className='other'>
                <Segment clearing className='other-header'>
                    <Segment floated='left'>
                        {tr('ADD_OTHER')}
                    </Segment>
                    <Segment floated='right'>
                        <Image src={cancel} onClick={(_e) => {
                            this.props.onCancel()
                        }}/>
                    </Segment>
                    <Segment floated='right'>
                        <Image src={done} onClick={(_e) => {
                            this.saveExercise()
                        }}/>
                    </Segment>
                </Segment>
                <Segment className='other-body'>
                    <Form>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>{tr('TITLE')}</label>
                                <input
                                    name='title'
                                    maxLength={50}
                                    value={this.state.exercise.title}
                                    placeholder={tr('WRITE_HERE_THE_EXERCISE_TITLE')}
                                    onChange={(e) => {
                                        this.changeValue(e.target.name, e.target.value)
                                    }}
                                />
                                {
                                    !_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.title) && (
                                        <div className='error-message'>{this.state.errors.title}</div>
                                    )
                                }
                                <label>{tr('URL_ADDRESS')}</label>
                                <input
                                    name='custom_link'
                                    maxLength={200}
                                    value={this.state.exercise.custom_link}
                                    placeholder={tr('PASTE_LINK_PLACEHOLDER')}
                                    onChange={(e) => {
                                        this.changeValue(e.target.name, e.target.value)
                                    }}
                                />

                            </Form.Field>
                            <Form.Field>
                                <label>{tr('DESCRIPTION')}</label>
                                <textarea
                                    name='description'
                                    maxLength={300}
                                    value={this.state.exercise.description}
                                    placeholder={tr('WRITE_HERE_THE_EXERCISE_DESCRIPTION')}
                                    onChange={(e) => {
                                        this.changeValue(e.target.name, e.target.value)
                                    }}
                                />
                                {
                                    !_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.description) && (
                                        <div className='error-message'>{this.state.errors.description}</div>
                                    )
                                }
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Segment>
            </Container>
        )
    }
}

export default OtherExercise



// WEBPACK FOOTER //
// ./src/components/participant-session/exercises/other-exercise.js